<div class="d-flex w-100 px-2 pt-3">
  <h2 mat-dialog-title>Login</h2>
</div>
<mat-dialog-content class="dialog-container px-0">
  <div class="container-fluid">
    <!-- <p class="text-center">Sign Up with exisiting accounts</p> -->

    <!-- social buttons -->
    <div class="alert alert-danger alert-dismissible w-100" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <form [formGroup]="loginForm" class="pt-3" (ngSubmit)="login()">
      <div class="row justify-content-center">
        <div class="col-9 my-3">
          <!-- email -->
          <div class="mb-3">
            <div class="position-relative">
              <input type="text" class="form-control" placeholder="Enter email / mobile number" formControlName="email"
                #emailCtrl (blur)="validateEmailOrMobile()" />
              <button (click)="enableMobileInput()" *ngIf="emailCtrl.disabled" type="button"
                class="position-absolute end-0 top-0" mat-icon-button>
                <i class="bi bi-pencil-square" style="font-size: 1.5rem;"></i>
              </button>
            </div>
            <small class="text-danger" *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.errors">Please
              enter valid email or mobile number</small>
          </div>

          <!-- password -->
          <div class="mb-3 input-group">
            <input [type]="passwordInputType" class="form-control" placeholder="password" formControlName="password" />
            <button class="app-icon-btn position-absolute end-0 border-0" type="button"
              (click)="togglePasswordType(passwordInputTypes.passwordInputType)">
              <i [class]="[
                'bi',
                passwordInputType === 'password'
                  ? 'bi-eye-slash-fill'
                  : 'bi-eye-fill'
              ]"></i>
            </button>
          </div>

          <!-- OTP TImer -->
          <div>
            <p class="text-end" *ngIf="otpResendTimer.current !== otpResendTimer.default">
              Resend OTP in
              <span class="text-danger">
                {{otpResendTimer.formatedTime}}
              </span>
            </p>

            <p class="text-end" *ngIf="isResendEnabled">
              Resend OTP
              <button class="btn app-icon-btn bg-app-secondary" type="button" (click)="sendOTP()">
                <i class="bi bi-arrow-clockwise"></i>
              </button>
            </p>
          </div>

          <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <label class="remember-me-input">
                <input type="checkbox" formControlName="rememberMe" />
                Remember me
              </label>
            </div>
            <div>
              <button class="btn btn-link text-dark forgot-password-link" style="font-size: 14px;" type="button"
                (click)="openForgotPassword()">Forgot password</button>
            </div>
          </div>

          <!-- Sign up button -->
          <div class="text-center">
            <button class="btn app-btn-dark my-3 text-uppercase" type="submit" [disabled]="loginForm.invalid">Login</button>
          </div>
        </div>
      </div>
    </form>

    <div class="row justify-content-center d-none my-3">
      <div class="col-12 text-center">Or login with</div>
      <div class="col-12 d-flex justify-content-center">
        <div class="mx-1">
          <a class="social-button btn-outline-dark" [href]="getSocialLoginURL('facebook')">
            <i class="bi bi-facebook"></i>
          </a>
        </div>
        <div class="mx-1">
          <a class="social-button btn-outline-dark d-grid app-place-content-center"
            [href]="getSocialLoginURL('google')">
            <i class="bi bi-google"></i>
          </a>
        </div>
      </div>
    </div>

  </div>
</mat-dialog-content>
<!-- <mat-dialog-actions> -->
<div class="container-fluid mb-2 footer">
  <div class="row align-items-center justify-content-between py-2">
    <div class="col-8">Don't Have An Account?</div>
    <div class="col-4 text-end">
      <button class="btn app-btn-dark text-uppercase" type="button" (click)="openSignUp()">Signup</button>
    </div>
  </div>
</div>
<!-- </mat-dialog-actions> -->
